export default {
  LIST_FETCHED: 'STATION_HIERARCHIES_FETCHED',
  LIST_LOAD: 'STATION_HIERARCHIES_LOAD',
  ITEM_DETAIL: 'STATION_HIERARCHIES_DETAIL',
  BUTTON_LOAD: 'STATION_HIERARCHIES_BUTTON_LOAD',
  PARENT_ACTIONS_FETCHED: 'STATION_HIERARCHIES_PARENT_ACTIONS_FETCHED',
  PARENT_ACTIONS_LOAD: 'STATION_HIERARCHIES_PARENT_ACTIONS_LOAD',
  PARENT_ACTIONS_SAVE_LOAD: 'STATION_HIERARCHIES_PARENT_ACTIONS_SAVE_LOAD',
};
